import AttachmentWellViewState from '../schema/AttachmentWellViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('changeTotalClassicAttachmentSize')(function changeTotalClassicAttachmentSize(
    attachmentWell: AttachmentWellViewState,
    offset: number
) {
    attachmentWell.totalClassicAttachmentSize += offset;
});
